import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { ProductionOrder, ProductionOrderCreate, ProductionOrderFilter } from '../data/productionOrder';

export function createProductionOrderService(client: AxiosInstance) {
  return createCrudService<ProductionOrder, ProductionOrderCreate, ProductionOrderFilter>(
    client,
    '/manufacturing/ProductionOrder',
    'id',
  );
}

export type ProductionOrderService = CrudService<ProductionOrder, ProductionOrderCreate, ProductionOrderFilter>;
